export type MessageGroupPosition = 'single' | 'first' | 'middle' | 'last';

const bubbleRadius = '18px';
const groupedRadius = '6px';

export const getMessageBubbleRadius = (
  isSelf: boolean,
  groupPosition: MessageGroupPosition = 'single'
) => {
  const isSingle = groupPosition === 'single';
  const isFirst = groupPosition === 'first';
  const isLast = groupPosition === 'last';

  return {
    borderTopLeftRadius: isSelf ? bubbleRadius : isSingle || isFirst ? bubbleRadius : groupedRadius,
    borderBottomLeftRadius: isSelf
      ? bubbleRadius
      : isSingle || isLast
        ? bubbleRadius
        : groupedRadius,
    borderTopRightRadius: isSelf
      ? isSingle || isFirst
        ? bubbleRadius
        : groupedRadius
      : bubbleRadius,
    borderBottomRightRadius: isSelf
      ? isSingle || isLast
        ? bubbleRadius
        : groupedRadius
      : bubbleRadius,
  };
};
